module.exports = __webpack_public_path__ + "images/146_4096.jpg";